export default __webpack_public_path__ + "static/media/background-mobile.132d4261.jpg";